<template>
  <div >
    <v-data-iterator
      :server-items-length="total"
      :items="items"
      :items-per-page.sync="ipp"
      :page.sync="page"
      no-data-text="No items found"
      hide-default-footer
      class="d-flex flex-column overflow-hidden" 
    >
      <template v-slot:header v-if="title != undefined">
        <slot name="topbar" id="topbar">
          <v-toolbar  dark color="blue darken-3" class="shrink mb-1">
            <div class="headline white--text mr-2 text-truncate">
              {{title == null ? 'Title' : title}}
            </div>
          </v-toolbar>
        </slot>
      </template>
      
      <template v-slot:default="props" >
        <div style="padding: 20px">
        <v-row class="fill-height overflow-auto" >
          <v-col
            v-for="item in props.items"
            :key="item.id"
            :cols="12 / itemsPerRow"
            class="py-2"
          >
          <component  :is="displayItem" :displayArgs.sync="changedArgs" :item="item" :itemHeight.sync="itemHeight" />
          </v-col>
        </v-row>
        </div>
      </template>
      
      <template v-slot:footer ref="iterfooter">
        <div style="padding-right: 20px">
        <v-row
          class="no-gutters mt-auto py-2 shrink"
          align="center"
          justify="center"
        >

          <v-spacer></v-spacer>
          <span class="mr-4 grey--text">
            Page {{ page }} of
            <span
              v-text="numberOfPages"
              class="font-weight-bold primary--text"
            ></span>
          </span>
          <v-btn
            small
            dark
            rounded
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            small
            dark
            rounded
            color="blue darken-3"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
        </div>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
export default {
  props: ['title', 'items', 'displayItem', 'height', 'short', 'extra', 'total', 'displayArgs'],
  data() {
    return {
      bottom: false,
      rowsPerPageArray: [2, 3, 4, 5, 6],
      rpp: 4,
      page: 1,
      busy: false,
      itemHeight: 100,
      changedArgs: null
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.total / this.ipp)
    },
    rowsPerPage() {
      return this.rpp
    },
    itemsPerRow() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1
        case "sm":
          return 2
        case "md":
          return 2
        case "lg":
          return 3
        case "xl":
          return 3
      }
    },
    ipp: {
      get: function () {
        return Math.ceil(this.rowsPerPage * this.itemsPerRow)
      },
      set: function () {},
    },
  },
  watch: {
    itemHeight: {
      immediate: false,
      handler (val) {
        if (val != undefined) {
          this.calcRowsPerPage()
        }
      }
    },
    changedArgs(val) {
      this.$emit('update:changedArgs', val)
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
      this.$emit("update:currentPage", {page: this.page, items: this.ipp})
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
      this.$emit("update:currentPage", {page: this.page, items: this.ipp})
    },
    calcRowsPerPage() {
      let minItemHeight = this.itemHeight + 25
      if (minItemHeight == undefined) return
      let containerHeight = window.innerHeight -270
      this.rpp = Math.floor(
        (Math.max(containerHeight, minItemHeight) ) / minItemHeight
      );
      this.$emit("update:currentPage", {page: this.page, items: this.ipp})
    },
  },
  mounted() {
    this.calcRowsPerPage()
    window.addEventListener("resize", () => {
      //debounce
      if (!this.busy) {
        this.busy = true;
        setTimeout(() => {
          this.calcRowsPerPage();
          this.busy = false;
        }, 300);
      }
    });
  },
};
</script>
<style >
.topbar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6em;
  z-index: 2;
}
.mh-100 {
  height: calc(100vh - 100px);
  max-height: calc(100vh - 100px);
}

.mh-200 {
  /* height: calc(100vh - 250px);
  max-height: calc(100vh - 250px); */
}

.overflow-hidden {
  overflow: hidden;
}

.theme--light.v-application {
  background-color: #ddd;
}
</style>